import React, { Component } from "react";
import { Button, Row, Col, Modal, Tab, Nav } from "react-bootstrap";
import { Calendar, Mic, MicOff, PlusCircle, XCircle } from "react-feather";
import DatePicker from "react-datepicker";
import Url from "app/shared/constants/Url";
import CompanyList from "./CompanyList";
import ServiceList from "./ServiceList";
import ProjectList from "./ProjectList";
import { requiredMessage } from "app/shared/constants/Messages";
import { ReactMic } from "react-mic";
import moment from "moment";
import CommonDropdown from "./CommonDropdown";
import TimePicker from "react-times";
import LoadingImage from "app/shared/components/Loader/LoadingImage";
import axios from "axios";
import VoiceRecorder from "app/shared/components/VoiceRecorder/VoiceRecorder";
import { withRouter } from "react-router-dom";
import SubmitImage from "../../../../assets/images/submit.png";
import AudioPlayer from "react-h5-audio-player";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import AsyncSelect from "react-select/async";
import FetchEMList from "./services/fetchEMList";

import LowSpace from "app/shared/components/Popups/LowSpace";
//import MyDropzone from "app/shared/components/DocumentModal/Dropzone";
import ReportDropZone from "../DocumentModal/ReportDropZone";
import { formatLocalDate } from "app/shared/utility/tzUtilFunction";

import { ErrorToast } from "../Popups/ToastMessage";
import { isIntegerNumber, renderToolTip } from "app/shared/utility/formHelper";
const qs = require("qs");

const DEPT_URL = Url.departmentList;
const ZONE_URL = Url.zoneList;
const ACT_URL = Url.activitylist;
const Div_URL = Url.divisionList;

const hasNumber = /\d/;
const getDb = () => {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "stageclide";
  }

  if (hostname.endsWith(".clideanalyser.in")) {
    const db = hostname.replace(".clideanalyser.in", "").trim();

    if (db === "qaclide") {
      return "stageclide";
    }

    return db;
  }

  return hostname.split(".")[0] || "stageclide";
};

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    width: "100%",
    minHeight: "32px",
    maxHeight: "32px",
    border: "1px solid #E6E6E6",
    borderRadius: "6px",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #FF5A36",
    },
    backgroundColor: state.isDisabled ? "#F9F9F9" : "white",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.7 : 1,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    height: "32px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "#444444",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#999",
    fontSize: "16px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#FFE5E0",
    borderRadius: "4px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "13px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#FF5A36",
    "&:hover": {
      backgroundColor: "#FF5A36",
      color: "white",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    width: "100%",
    zIndex: 9999,
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#FF5A36"
      : state.isFocused
        ? "#FFE5E0"
        : "white",
    color: state.isSelected ? "white" : "#444444",
    cursor: "pointer",
    padding: "10px 12px",
    fontSize: "14px",
    "&:active": {
      backgroundColor: "#FF5A36",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
};

class TrainingReport extends Component {
  constructor(props) {
    super(props);

    let date = new Date();
    let hours = new Date();
    hours = hours.setHours(hours.getHours() + 1);

    this.state = {
      formHideField: this.props.hideFieldList,
      reportType: this.props.reportType,
      companyList: [],
      serviceList: [],
      projectList: [],
      zoneList: [],
      locationList: [],
      departmentList: [],
      divisionList: [],
      searchData: [],
      searchTopicData: [],
      searchEmployeeData: [],
      tempFiles: [],
      activityList: [],
      subActivityList: [],
      subActivityError: false,
      selectedSubActivity: null,
      typeList: [{ type_id: 2, actvity: "TBT" }],
      observationText: "",
      evidenceFileList: [],
      evidenceUrlList: [],
      selectedCompanyId: this.props.isFromAction
        ? this.props.formActionData?.project.company_id
        : null,
      selectedServiceId: this.props.isFromAction
        ? this.props.formActionData?.project.service_id
        : null,
      selectedProjectId: this.props.isFromAction
        ? this.props.formActionData?.project.id
        : null,
      activeModule: 1,
      selectedActivity: this.props.isFromAction
        ? this.props.formActionData?.activity.id
        : null,
      clearDropZone: false,
      selectedSeverity: null,
      selectedTargetDate: new Date(),
      maxDatepickerDate: new Date(),
      minDatepickerDate: new Date(),
      isMaxPersonValidate: false,
      maxPersonValidationMessage: "",
      validDateField: "",
      // selectedType: this.props.isFromAction ? "1" : null,
      selectedType: this.props.reportType == "training" ? "1" : "2",
      selectedFaculty: null,
      selectedConductedStartDate: new Date(),
      selectedConductedEndDate: hours,
      topic: "",
      topicId: null,
      noOfAtendees: "",
      employee_attendees_count: null,
      contractor_attendees_count: null,
      employee_attendees_countError: false,
      contractor_attendees_countError: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      lat: 0,
      long: 0,
      observationError: false,
      observationTopic: false,
      companyError: false,
      serviceError: false,
      projectError: false,
      zoneError: false,
      departmentError: false,
      contractorError: false,
      divisionError: false,
      locationError: false,
      typeActError: false,
      activityError: false,
      typeError: false,
      isMaxPersonValidateError: false,
      noOfAtendeesError: false,
      showRecorderModal: false,
      recordAudio: false,
      observationAudio: "",
      observationURL: "",
      recordingFor: "observation",

      sucesssPopup: false,
      reportNumber: 0,
      lowStorageMessage: "",
      lowStorageStatus: 200,
      showLowStoragePopup: false,
      showZoneDropdown: true,
      conductedFor: null,
      conductedForError: false,
      trainingType: null,
      trainingTypeError: false,
      schedule: null,
      isSheduleChecked: false,
      selectedFile: "",
      currentDate: new Date(),
      trainingAssignRights: {},
      conduct: [],
      male_attendees_count: 0,
      female_attendees_count: 0,
      userData: JSON.parse(localStorage.getItem("userData")),
      organisationSetting: false,
      riskRegisterTree: null, // /riskRegister/getByActivity response
      projectAutoFill: {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      },
      searchFiledUsers: [],
      searchEmployeeUsers: [],
    };
  }

  _fetchOrganisationSetting = async () => {
    try {
      const response = await axios.get(Url.organisationSettingByDb, {
        params: { db: getDb() },
      });

      const enabled = !!response?.data?.data?.organisationSetting;

      this.setState({ organisationSetting: enabled });

      return enabled;
    } catch (error) {
      this.setState({ organisationSetting: true });
      return true; // fallback
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.hideFieldList !== prevState.formHideField) {
      return nextProps.hideFieldList;
    }
    return null;
  }

  _closeSuccessPopup = async () => {
    await this.setState({ sucesssPopup: false });
    await this._clearForm();
    this.props.close();
    this.props.history.push("/");
  };

  _continueReporting = async () => {
    this.setState({ sucesssPopup: false });
    await this._continueReportingClearForm();

    if (!this.state.organisationSetting) {
      await this._fetchServiceList();
    }
  };

  _getLocation = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setState((prevState) => {
          let { lat, long } = prevState;
          lat = position.coords.latitude;
          long = position.coords.longitude;
          return { lat, long };
        });
      });
    }
  };

  componentDidMount = async () => {
    const organisationSetting = await this._fetchOrganisationSetting();
    if (organisationSetting) {
      await this._fetchCompanyList();
    } else {
      await this._fetchServiceList();
    }

    await this._getLocation();
    this.props.setClick(this._submitTraining);
    if (
      this.state.userData.designation_flag == 1 ||
      this.state.userData.designation_flag == 5
    ) {
      this.setState({
        typeList: [
          { type_id: 1, actvity: "Training" },
          { type_id: 2, actvity: "TBT" },
        ],
      });
    }
    this._fetchParamList();
  };

  _fetchCompanyList = async () => {
    let params = {
      page: 0,
      size: 200,
      search: "",
    };
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPIGet(Url.companyList, params);

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { companyList } = prevState;
              companyList = response.data.data;
              return { companyList };
            });

            if (this.state.userData.designation_flag === 4) {
              this.setState(
                {
                  selectedCompanyId: response.data.data[0]["companyId"],
                },
                () =>
                  void this._fetchServiceList(
                    response.data.data[0]["companyId"],
                  ),
              );
            }

            this._setDataLoading(false);
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchParamList = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    await axios
      .get(
        this.state.selectedType == 1
          ? Url.training.trainingSettingData
          : Url.tbt.tbtSettingData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          params: {
            auth_key: token,
            user_id: userId,
          },
        },
      )
      .then(async (response) => {
        if (response.data.status == 200) {
          const transformedData = response.data.data.reduce((acc, item) => {
            // Convert parameter to camelCase
            let camelCaseKey = item.parameter
              .toLowerCase()
              .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());

            acc[camelCaseKey] = item.value === 1;
            if (item.parameter === "Evidence_Limit")
              acc["evidenceLimit"] = item.value;

            // Assign boolean value based on `value`
            return acc;
          }, {});

          await this.setState(
            (prevState) => {
              let { param_list, dataLoading } = prevState;
              param_list = transformedData;
              dataLoading = false;
              return { param_list, dataLoading };
            },
            async () => {
              await this._fetchOptionList();
            },
          );
        }
      })
      .catch(() => {});
  };

  _fetchOptionList = async () => {
    const tempUserId = localStorage.getItem("userId");
    const tempToken = localStorage.getItem("token");

    let requestData = {
      auth_key: tempToken,
      user_id: tempUserId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    if (this.state.userData?.div_dept == 0) this._fetchDepartmentList();

    axios
      .all([
        // Zone List
        axios.post(ZONE_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        // Activity List
        axios.post(ACT_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        //division list
        axios.post(Div_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
      ])
      .then(
        axios.spread(async (zone, activity, division) => {
          await this.setState((prevState) => {
            let { activityList, zoneList, divisionList, dataLoading } =
              prevState;
            zoneList = zone.data.status === 200 ? zone.data?.data : [];

            activityList =
              activity.data.status === 200 ? activity.data?.data : [];

            divisionList =
              division.data.status === 200 ? division.data.data : [];

            dataLoading = false;

            return {
              zoneList,
              activityList,
              divisionList,
              dataLoading,
            };
          });
        }),
      )
      .catch((error) => {
        this._setDataLoading(false);
      });
  };

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  _fetchServiceList = async (companyId = null) => {
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.serviceList,
        { "Content-Type": "application/x-www-form-urlencoded" },
        { company_id: companyId },
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { serviceList } = prevState;
              serviceList = response.data.data;
              return { serviceList };
            });
            if (this.state.userData.designation_flag === 4) {
              this.setState(
                {
                  selectedServiceId: response.data.data[0]["service_id"],
                },
                () =>
                  void this._fetchProjectList(
                    response.data.data[0]["service_id"],
                  ),
              );
            }
            this._setDataLoading(false);
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _companyChangeHandle = async (companyId) => {
    this.setState((prevState) => {
      let { selectedCompanyId, companyError } = prevState;
      selectedCompanyId = companyId;
      companyError = companyId ? false : true;
      return { selectedCompanyId, companyError };
    });
    this.setState({ selectedServiceId: null, serviceList: [] });
    await this._resetDropdwon();
    if (companyId) {
      this._fetchServiceList(companyId);
    }
  };

  _serviceChangeHandle = async (serviceId) => {
    await this.setState((prevState) => {
      let { selectedServiceId, serviceError } = prevState;
      selectedServiceId = serviceId;
      serviceError = serviceId ? false : true;
      return { selectedServiceId, serviceError };
    });
    await this._resetDropdwon();
    this._fetchProjectList(serviceId);
  };

  _resetDropdwon = async (projectReset = true) => {
    await this.setState((prevState) => {
      let {
        selectedProjectId,
        selectedActivity,
        projectList,
        activityList,
        divisionList,
        departmentList,
        zoneList,
        locationList,
        selectedLocationId,
        selectedDivisionId,
        selectedDepartmentId,
        selectedZoneId,
      } = prevState;

      if (projectReset) {
        selectedProjectId = null;
        projectList = [];
      }

      selectedActivity = null;
      activityList = [];

      departmentList = [];
      locationList = [];
      zoneList = [];
      divisionList = [];

      selectedLocationId = null;
      selectedDivisionId = null;
      selectedDepartmentId = null;
      selectedZoneId = null;

      return {
        selectedProjectId,
        selectedActivity,
        projectList,
        activityList,
        divisionList,
        departmentList,
        zoneList,
        locationList,
        selectedLocationId,
        selectedDivisionId,
        selectedDepartmentId,
        selectedZoneId,
      };
    });
  };

  _fetchProjectList = async (serviceId) => {
    let requestData = {
      service_id: serviceId,
      module_name: "training",
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.projectListForm,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            this.setState((prevState) => {
              let { projectList } = prevState;
              projectList = response.data.data;
              return { projectList };
            });
            if (this.state.userData.designation_flag === 4) {
              const project = response.data.data[0];
              const { project_id, contractor_flag, zone_location_flag } =
                project;

              this.setState(
                {
                  selectedProjectId: project_id,
                  selectedContractorId: contractor_flag,
                  showZoneDropdown: Boolean(zone_location_flag),

                  ...(this.state.organisationSetting
                    ? {
                        projectAutoFill: {
                          projectCategory: project.project_category ?? "",
                          projectCategoryId:
                            project.project_category_id ??
                            project.projectCategoryId ??
                            project.project_category ??
                            "",
                          region: project.region ?? "",
                          state: project.state ?? "",
                          city: project.city ?? "",
                        },
                      }
                    : {}),
                },
                async () => {
                  await this._fetchOptionList();
                  this._fetchTrainingAssignRights();
                },
              );
            }
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _projectChangeHandle = async (projectId) => {
    const project = this.state.projectList.find(
      (data) => data.project_id == projectId,
    );

    await this._resetDropdwon(false);

    this.setState((prevState) => {
      let { selectedProjectId, projectError, showZoneDropdown, projectList } =
        prevState;

      // check contractor flag
      let index = projectList.findIndex((item) => projectId == item.project_id);

      const isZone = projectList[index].zone_location_flag;
      showZoneDropdown = isZone == 0 ? false : true;

      selectedProjectId = projectId;
      projectError = projectId ? false : true;

      // UAUC + setting ON → auto-fill Project Details from the selected project
      if (this.state.organisationSetting && project) {
        this.setState({
          projectAutoFill: {
            projectCategory: project.project_category ?? "",

            projectCategoryId:
              project.project_category_id ??
              project.projectCategoryId ??
              project.project_category ??
              "",
            region: project.region ?? "",
            state: project.state ?? "",
            city: project.city ?? "",
          },
        });
      }

      return { selectedProjectId, projectError, showZoneDropdown };
    });
    await this._fetchOptionList();
    this._fetchTrainingAssignRights();
  };

  _fetchTrainingAssignRights = async () => {
    const tempUserId = localStorage.getItem("userId");
    const tempToken = localStorage.getItem("springToken");

    let requestData = {
      auth_key: tempToken,
      user_id: tempUserId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
    };

    var ContentType = {
      // headers: {
      //   "Content-Type": "application/x-www-form-urlencoded",
      // },
      // params: {
      //   auth_key: tempToken,
      //   user_id: tempUserId,
      // }
    };

    await axios
      .post(
        Url.training.assignTrainingUserNew,
        qs.stringify(requestData),
        ContentType,
      )
      .then(async (response) => {
        if (response.data.status == 200) {
          this.setState({
            dataLoading: false,
            trainingAssignRights: response.data.data.training_rights_user,
          });

          if (this.state.trainingAssignRights.trainingrightsId) {
            this.setState({
              typeList: [
                { type_id: 1, actvity: "Training" },
                { type_id: 2, actvity: "TBT" },
              ],
              // selectedType: 1,
            });
          } else {
            this.setState({
              typeList: [{ type_id: 2, actvity: "TBT" }],
              // selectedType: 2,
            });
          }
        }
      })
      .catch(async (error) => {
        await this.setState({
          dataLoading: false,
        });
      });
  };

  _divisionChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedDivisionId, divisionError } = prevState;
      selectedDivisionId = id;
      divisionError = id ? false : true;
      return { selectedDivisionId, divisionError };
    });
    await this._fetchDepartmentList();
  };

  _fetchDepartmentList = async () => {
    let requestData = {
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
      divisionId: this.state.selectedDivisionId,
      // zone_id: zoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        DEPT_URL,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { departmentList } = prevState;
              departmentList = response.data.data;
              return { departmentList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  // Shared rule: Department is a valid alternative to Zone+Location.
  // Which one(s) apply depends on div_dept / formHideField / showZoneDropdown.
  // Pass explicit overrides for whichever field just changed, instead of
  // trusting this.state (setState is async, so state may be stale here).
  _evaluateDeptZoneLocationRequirement = (overrides = {}) => {
    const {
      userData,
      formHideField,
      showZoneDropdown,
      selectedDepartmentId,
      selectedZoneId,
      selectedLocationId,
    } = this.state;

    const departmentId =
      "selectedDepartmentId" in overrides
        ? overrides.selectedDepartmentId
        : selectedDepartmentId;
    const zoneId =
      "selectedZoneId" in overrides ? overrides.selectedZoneId : selectedZoneId;
    const locationId =
      "selectedLocationId" in overrides
        ? overrides.selectedLocationId
        : selectedLocationId;

    const isDepartmentShown =
      userData?.div_dept === 0 &&
      !Object.values(formHideField || {}).includes("Department");

    const isZoneLocationShown = !!showZoneDropdown;

    const hasDepartment = !!departmentId;
    const hasZoneLocation = !!zoneId && !!locationId;

    if (!isDepartmentShown && !isZoneLocationShown) {
      return { departmentError: false, zoneError: false, locationError: false };
    }

    if (isDepartmentShown && !isZoneLocationShown) {
      return {
        departmentError: !hasDepartment,
        zoneError: false,
        locationError: false,
      };
    }

    if (!isDepartmentShown && isZoneLocationShown) {
      return {
        departmentError: false,
        zoneError: !hasZoneLocation,
        locationError: !hasZoneLocation,
      };
    }

    const satisfied = hasDepartment || hasZoneLocation;
    return {
      departmentError: !satisfied,
      zoneError: !satisfied,
      locationError: !satisfied,
    };
  };

  _departmentChangeHandle = (id) => {
    const errors = this._evaluateDeptZoneLocationRequirement({
      selectedDepartmentId: id,
    });

    this.setState({
      selectedDepartmentId: id,
      ...errors,
    });
  };

  _zoneChangeHandle = (zoneId) => {
    const errors = this._evaluateDeptZoneLocationRequirement({
      selectedZoneId: zoneId,
    });

    this.setState(
      {
        selectedZoneId: zoneId,
        ...errors,
      },
      () => {
        this._fetchLocationList();
      },
    );
  };

  _locationChangeHandle = (id) => {
    const errors = this._evaluateDeptZoneLocationRequirement({
      selectedLocationId: id,
    });

    this.setState({
      selectedLocationId: id,
      ...errors,
    });
  };

  // _departmentChangeHandle = async (id) => {
  //   await this.setState((prevState) => {
  //     let {
  //       selectedDepartmentId,
  //       departmentError,
  //       contractorError,
  //       locationError,
  //       zoneError,
  //     } = prevState;
  //     selectedDepartmentId = id;
  //     departmentError = id ? false : true;
  //     const isFieldShownMapAndValid = {
  //       isValidDepartment: !!selectedDepartmentId,
  //       isValidContactor: !!selectedDepartmentId,
  //       isValidLocation: !!selectedDepartmentId,
  //       isValidZone: !!selectedDepartmentId,

  //       isShownDepartment: !Object.values(prevState.formHideField).includes(
  //         "Department",
  //       ),
  //       isShownContactor: prevState.showContractorDropdown,
  //       isShownLocation: prevState.showLocationDropdown,
  //       isShownZone: prevState.showZoneDropdown,
  //     };

  //     if (isFieldShownMapAndValid.isShownDepartment) {
  //       departmentError = !selectedDepartmentId;
  //     }

  //     if (isFieldShownMapAndValid.isShownContactor) {
  //       contractorError = !selectedDepartmentId;
  //     }

  //     if (
  //       isFieldShownMapAndValid.isShownLocation &&
  //       isFieldShownMapAndValid.isShownZone
  //     ) {
  //       locationError = !selectedDepartmentId;
  //       zoneError = !selectedDepartmentId;
  //     }

  //     return {
  //       selectedDepartmentId,
  //       departmentError,
  //       contractorError,
  //       locationError,
  //       zoneError,
  //     };
  //   });
  //   // if (this.state.userData?.designation_flag != 6)
  //   //   await this._fetchClosingRightUserList();
  // };

  // _zoneChangeHandle = async (zoneId) => {
  //   await this.setState((prevState) => {
  //     let { selectedZoneId, departmentError, zoneError } = prevState;
  //     selectedZoneId = zoneId;
  //     zoneError = zoneId ? false : true;

  //     const isFieldShownMapAndValid = {
  //       isValidDepartment: !!selectedZoneId,
  //       isValidZone: !!selectedZoneId,

  //       isShownDepartment: !Object.values(prevState.formHideField).includes(
  //         "Department",
  //       ),
  //       // isShownLocation: prevState.showLocationDropdown,
  //       isShownZone: prevState.showZoneDropdown,
  //     };

  //     if (isFieldShownMapAndValid.isShownDepartment) {
  //       departmentError = !selectedZoneId;
  //     }
  //     return {
  //       selectedZoneId,
  //       departmentError,
  //       zoneError,
  //     };
  //   });

  //   await this._fetchLocationList();
  // };

  _fetchLocationList = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
      zone_id: this.state.selectedZoneId,
      // zone_id: zoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.locationList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { locationList } = prevState;
              locationList = response.data.data;
              return { locationList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  // _locationChangeHandle = async (id) => {
  //   await this.setState((prevState) => {
  //     let { selectedLocationId, departmentError, locationError } = prevState;
  //     selectedLocationId = id;
  //     locationError = id ? false : true;

  //     const isFieldShownMapAndValid = {
  //       isValidDepartment: !!selectedLocationId,
  //       isValidLocation: !!selectedLocationId,
  //       isValidZone: !!selectedLocationId,

  //       isShownDepartment: !Object.values(prevState.formHideField).includes(
  //         "Department",
  //       ),
  //       isShownLocation: prevState.showLocationDropdown,
  //       isShownZone: prevState.showZoneDropdown,
  //     };

  //     if (isFieldShownMapAndValid.isShownDepartment) {
  //       // departmentError = !prevState.selectedDepartmentId;
  //       departmentError = !selectedLocationId;
  //     }

  //     return {
  //       selectedLocationId,
  //       locationError,
  //       departmentError,
  //     };
  //   });
  //   // if (this.state.userData?.designation_flag != 6)
  //   //   await this._fetchClosingRightUserList();
  // };

  _activityChangeHandle = async (id) => {
    this.setState((prevState) => {
      let { selectedActivity, activityError } = prevState;
      selectedActivity = id;
      activityError = id ? false : true;
      return { selectedActivity, activityError };
    });
    if (this.state.param_list?.subActivity) {
      if (this.state.organisationSetting) {
        await this._fetchRiskRegisterByActivity(id);
      }
    }
  };

  // Fetch the risk-register tree for an activity and seed the dropdowns.
  _fetchRiskRegisterByActivity = async (activityId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("springToken");
    try {
      const response = await axios.get(Url.riskRegisterByActivity, {
        params: { user_id: userId, auth_key: token, activityId },
        headers: { accept: "application/json" },
      });
      const data = response?.data?.data || null;
      const subActivities = data?.subActivities || [];
      this.setState({
        riskRegisterTree: data,
        subActivityList: subActivities.map((sa) => ({
          name: sa.sub_activity_name || sa.subActivityName || sa.name || "",
          id: sa.sub_activity_id || sa.subActivityId || sa.id || 0,
        })),
        selectedSubActivity: null,
        subActivityError: false,
      });
    } catch (error) {
      this.setState({
        riskRegisterTree: null,
        subActivityList: [],
      });
    }
  };

  _subActivityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSubActivity, subActivityError } = prevState;
      selectedSubActivity = id;
      subActivityError = id ? false : true;
      return { selectedSubActivity, subActivityError };
    });

    if (this.state.organisationSetting) {
      const sa = (this.state.riskRegisterTree?.subActivities || []).find(
        (s) => s.subActivityId == id,
      );
    }
  };

  _typeChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedType, typeError, conduct } = prevState;
      selectedType = id;
      typeError = id ? false : true;
      conduct = [];
      console.log(selectedType);
      return { selectedType, typeError, conduct };
    });
  };

  _contractorChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedContractorId, contractorError } = prevState;
      selectedContractorId = id;
      contractorError = id ? false : true;
      return { selectedContractorId, contractorError };
    });
  };

  _severityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSeverity, severityError } = prevState;
      selectedSeverity = id;
      severityError = id ? false : true;
      return { selectedSeverity, severityError };
    });
  };

  _typeactChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedTypeAct, typeActError } = prevState;
      selectedTypeAct = id;
      typeActError = id ? false : true;
      return { selectedTypeAct, typeActError };
    });
  };

  _evidenceFileHandle = async (event) => {
    var evidence_file = Array.from(event.target.files);
    event.target.value = "";

    const lowStorage = this.checkLowStorage();

    lowStorage
      .then(async (response) => {
        const { status, msg } = response.data;

        if (status == 200) {
          var tempUrl = [];
          var filePromise = new Promise((resolve, reject) => {
            evidence_file.forEach((item, index) => {
              let temVar;

              let reader = new FileReader();
              reader.readAsDataURL(item);
              reader.onloadend = () => {
                tempUrl.push(reader.result);
                if (index === evidence_file.length - 1) {
                  return resolve(1);
                }
              };
            });
          });

          filePromise.then(async () => {
            await this.setState((prevState) => {
              let { evidenceFileList, evidenceUrlList } = prevState;
              const tempArr = evidence_file.map((item) => item);
              evidenceFileList = [...evidenceFileList, ...tempArr];
              evidenceUrlList = [...evidenceUrlList, ...tempUrl];
              return { evidenceFileList, evidenceUrlList };
            });
          });
        }
        await this.setState({
          lowStorageStatus: status,
          lowStorageMessage: msg,
          showLowStoragePopup: status == 200 ? false : true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  _handleChange = async (
    item = null,
    type = "observation",
    callback = () => {},
    isCallBackEnabled = false,
  ) => {
    await this.setState(
      (prevState) => {
        let {
          selectedConductedStartDate,
          selectedConductedEndDate,
          selectedType,
          conduct,
        } = prevState;
        switch (type) {
          case "observation":
            let { observationText, observationError, observationURL } =
              prevState;
            observationText = item;
            observationError = !observationURL && !item ? true : false;
            return { observationText, observationError };
            break;

          // case "topic":
          //   let { topic, topicError } = prevState;
          //   topic = item;
          //   topicError = item ? false : true;
          //   return { topic, topicError };
          //   break;
          case "topic":
            let { topicError } = prevState;
            topicError = item ? false : true;
            return {
              selectedTopic: item, // Store full object
              topicId: item?.value || null, // ID for backend
              topic: item?.label || "", // Name for backend/display
            };

          case "conducted_start_date":
            selectedConductedStartDate = item;
            var tempDate = new Date(item);
            selectedConductedEndDate = tempDate.setHours(
              tempDate.getHours() + 1,
            );

            return { selectedConductedStartDate, selectedConductedEndDate };
            break;

          case "conducted_end_date":
            selectedConductedEndDate = item;
            return { selectedConductedEndDate };
            break;

          // case "no_of_atendees":
          //   let { noOfAtendees, noOfAtendeesError } = prevState;
          //   noOfAtendees = item;
          //   noOfAtendeesError = this.state.selectedType !== "1" ? item > 0 ? false : true : false;
          //   return { noOfAtendees, noOfAtendeesError };
          //   break;
          case "employee_attendees_count":
            let { employee_attendees_count, employee_attendees_countError } =
              prevState;
            employee_attendees_count = item;
            employee_attendees_countError = item > 0 ? false : true;
            return { employee_attendees_count, employee_attendees_countError };
            break;
          case "contractor_attendees_count":
            let {
              contractor_attendees_count,
              contractor_attendees_countError,
            } = prevState;
            contractor_attendees_count = item;
            contractor_attendees_countError = item > 0 ? false : true;
            return {
              contractor_attendees_count,
              contractor_attendees_countError,
            };
            break;

          case "faculty":
            let { selectedFaculty, selectedFacultyError } = prevState;
            selectedFaculty = item;
            selectedFacultyError = item ? false : true;
            return { selectedFaculty, selectedFacultyError };
            break;

          case "conducted_for":
            let { conductedFor, conductedForError } = prevState;
            conductedFor = item;
            conductedForError =
              selectedType === "1"
                ? conduct?.length === 0
                  ? true
                  : false
                : item
                  ? false
                  : true;
            return { conductedFor, conductedForError };
            break;
          case "male_attendees_count":
            let { male_attendees_count } = prevState;
            male_attendees_count = item;
            return { male_attendees_count };
            break;
          case "female_attendees_count":
            let { female_attendees_count } = prevState;
            female_attendees_count = item;
            return { female_attendees_count };
            break;

          case "training_type":
            let { trainingType, trainingTypeError } = prevState;
            trainingType = item;
            trainingTypeError = item ? false : true;
            return { trainingType, trainingTypeError };
            break;

          default:
            return prevState;
            break;
        }
      },
      () => {
        if (isCallBackEnabled) {
          callback();
        }
      },
    );
  };

  _handleCheck = async () => {
    this.setState({
      isSheduleChecked: !this.state.isSheduleChecked,
    });

    let time = new Date();
    let addedTime = new Date();
    let endDateTime = new Date();
    addedTime = addedTime.setDate(time.getDate() + 1);

    var tempEndDate = new Date(time);
    var tempEndDateChecked = new Date(addedTime);
    if (!this.state.isSheduleChecked) {
      this.setState({
        selectedConductedStartDate: addedTime,
        selectedConductedEndDate: tempEndDateChecked.setHours(
          tempEndDateChecked.getHours() + 1,
        ),
      });
    } else {
      this.setState({
        selectedConductedStartDate: new Date(),
        selectedConductedEndDate: tempEndDate.setHours(
          tempEndDate.getHours() + 1,
        ),
      });
    }
  };

  _removePreviewFile = async (index = 0) => {
    await this.setState((prevState) => {
      let { evidenceFileList, evidenceUrlList } = prevState;
      evidenceFileList.splice(index, 1);
      evidenceUrlList.splice(index, 1);
      return { evidenceFileList, evidenceUrlList };
    });
  };

  checkLowStorage = () => {
    return import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.reportSetting.checkStorage,
      );

      return responseObj;
    });
  };

  _handleLowSpace = async (statusFlag) => {
    await this.setState({ showLowStoragePopup: false });
  };

  _formValidation = async () => {
    const tempObj = this.state;

    this.setState((prevState) => {
      prevState.observationError =
        tempObj.observationText || tempObj.observationURL ? false : true;

      if (this.state.organisationSetting) {
        prevState.companyError = tempObj.selectedCompanyId ? false : true;
      }

      if (
        this.state.param_list?.subActivity &&
        this.state.subActivityList.length > 0
      ) {
        prevState.subActivityError = tempObj.selectedSubActivity ? false : true;
      } else {
        prevState.subActivityError = false;
      }

      prevState.serviceError = tempObj.selectedServiceId ? false : true;

      prevState.projectError = tempObj.selectedProjectId ? false : true;

      prevState.typeError = tempObj.selectedType ? false : true;
      prevState.activityError = tempObj.selectedActivity ? false : true;
      prevState.isMaxPersonValidateError =
        tempObj.isMaxPersonValidate &&
        (this.state.param_list?.maleAttendance ||
          !!this.state.param_list?.femaleAttendance)
          ? true
          : false;

      prevState.topicError = tempObj.topic ? false : true;

      prevState.selectedFacultyError = tempObj.selectedFaculty ? false : true;

      // prevState.noOfAtendeesError = tempObj?.selectedType !== "1" ? tempObj.noOfAtendees > 0 ? false : true : false;

      prevState.employee_attendees_countError = this.state.conduct.includes(
        "Employee",
      )
        ? tempObj.employee_attendees_count > 0
          ? false
          : true
        : false;
      prevState.contractor_attendees_countError = this.state.conduct.includes(
        "Contractor",
      )
        ? tempObj.contractor_attendees_count > 0
          ? false
          : true
        : false;
      prevState.conductedForError = true
        ? tempObj?.conduct?.length === 0
          ? true
          : false
        : tempObj.conductedFor
          ? false
          : true;

      if (prevState.selectedType === "1") {
        prevState.trainingTypeError = tempObj.trainingType ? false : true;
      }

      const { departmentError, zoneError, locationError } =
        this._evaluateDeptZoneLocationRequirement();
      prevState.departmentError = departmentError;
      prevState.zoneError = zoneError;
      prevState.locationError = locationError;

      return prevState;
    });
  };

  _submitTraining = async () => {
    await this._formValidation();
    // Checking form have any Error
    let formErrorStatus;
    for (var propertyName in this.state) {
      if (propertyName.includes("Error")) {
        if (this.state[propertyName]) {
          console.log(propertyName);
          console.log(this.state[propertyName]);
          formErrorStatus = true;
          console.log("erroe");
          return;
        } else {
          formErrorStatus = false;
        }
        console.log(formErrorStatus);
      }
    }

    // If form not have error then submit form
    if (
      !formErrorStatus &&
      (this.state.isMaxPersonValidate === false ||
        !(
          !!this.state.param_list?.maleAttendance ||
          !!this.state.param_list?.femaleAttendance
        ))
    ) {
      // this.props.parentStateSetter(({
      //   apiLoading:true
      // }));
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("springToken");
      this.setState({
        activeModule: this.state.selectedType,
      });
      await this.setState({ dataLoading: true });

      this._setDataLoading(true);

      let soiData = new FormData();
      soiData.append("auth_key", token);
      soiData.append("user_id", userId);

      if (this.state.organisationSetting) {
        soiData.append("companyId", this.state.selectedCompanyId || 0);
        soiData.append(
          "projectCategory",
          this.state.projectAutoFill.projectCategoryId || "",
        );
        soiData.append("region", this.state.projectAutoFill.region || "");
        soiData.append("state", this.state.projectAutoFill.state || "");
        soiData.append("city", this.state.projectAutoFill.city || "");
      }

      soiData.append("service_id", this.state.selectedServiceId || 0);
      soiData.append("project_id", this.state.selectedProjectId || 0);

      soiData.append("activity", this.state.selectedActivity || 0);

      if (this.state.param_list?.subActivity) {
        soiData.append(
          "subActivity",
          this.state.selectedSubActivity ? this.state.selectedSubActivity : 0,
        );
      }
      soiData.append("what_all_covered", this.state.observationText || "");
      soiData.append(
        "conducted_for",
        this.state.conduct?.length > 1
          ? "Employee,Contractor"
          : this.state.conduct.join(),
      );
      soiData.append(
        "male_attendees_count",
        this.state.male_attendees_count || 0,
      );
      soiData.append(
        "female_attendees_count",
        this.state.female_attendees_count || 0,
      );
      soiData.append("training_type", this.state.trainingType || "");
      soiData.append("topic", this.state.topic || "");
      // if (this.state.selectedType !== "1") {
      //   soiData.append("atendees_count", this.state.noOfAtendees || 0);
      // }
      soiData.append("type", this.state.selectedType || 0);
      soiData.append("faculty", this.state.selectedFaculty || "");

      var conductedStartDate = formatLocalDate(
        this.state.selectedConductedStartDate,
      );
      var conductedEndDate = formatLocalDate(
        this.state.selectedConductedEndDate,
      );

      soiData.append("conducted_start_date", conductedStartDate || "");
      soiData.append(
        "conducted_end_date",
        this.state.selectedType === "1" ? conductedEndDate || "" : "",
      );

      soiData.append("lat", this.state.lat);
      soiData.append("lang", this.state.long);
      soiData.append("what_all_covered_record", this.state.observationAudio);
      // soiData.append("schedule", this.state.selectedType == 1 ? 0 : 1);
      if (this.state.isSheduleChecked) {
        soiData.append("schedule", 0);
      } else {
        soiData.append("schedule", 1);
      }

      soiData.append(
        "employee_attendees_count",
        this.state.employee_attendees_count || 0,
      );
      soiData.append(
        "contractor_attendees_count",
        this.state.contractor_attendees_count || 0,
      );

      soiData.append("zoneId", this.state.selectedZoneId || 0);
      soiData.append("locationId", this.state.selectedLocationId || 0);
      soiData.append("departmentId", this.state.selectedDepartmentId || 0);
      soiData.append("divisionId", this.state.selectedDivisionId || 0);
      soiData.append("topicId", this.state.topicId || 0);

      let incidentPersons = [];

      if (this.state.searchFiledUsers?.length) {
        const searchFiledUsersData = this.state.searchFiledUsers.map((el) => ({
          incidentPersonId: el.employeeId,
          searchIncidentPersonId: el.incident_person_id,
          incidentPersonName: el?.incident_person_name,
        }));

        incidentPersons = [...incidentPersons, ...searchFiledUsersData];
      }

      if (this.state.searchEmployeeUsers?.length) {
        const searchFiledUsersData = this.state.searchEmployeeUsers.map(
          (el) => ({
            incidentPersonId: el?.clientEmployeeId,
            searchIncidentPersonId: el?.id,
            incidentPersonName: el?.displayName,
          }),
        );

        incidentPersons = [...incidentPersons, ...searchFiledUsersData];
      }

      soiData.append("invitedPersonString", JSON.stringify(incidentPersons));

      // Evidence File

      if (this.state.tempFiles.length) {
        this.state.tempFiles.forEach((el) => {
          soiData.append("file", el || "");
        });
      }

      soiData.append("fileStatus", this.state.selectedFile ? 1 : 0);

      var ContentType = {
        "Content-Type": "multipart/form-data",
      };

      let URL = Url.training.trainingReport;

      await axios
        .post(URL, soiData, ContentType)
        .then(async (response) => {
          this._setDataLoading(false);

          if (response.data.status === 200) {
            this.setState({
              clearDropZone: true,
            });

            await this.setState({
              reportNumber: response.data.report_number,
              sucesssPopup: true,
            });
            await this._continueReportingClearForm();
          } else {
            ErrorToast(response.data?.msg || "Something went wrong!");
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
          console.log(error);
        });
      // .finally(() =>{
      //   this.props.parentStateSetter(({
      //     apiLoading:false
      //   }));
      // })
    }
  };

  _showRecorder = async (flag = false, type = "observation") => {
    if (flag) {
      const lowStorage = this.checkLowStorage();
      lowStorage
        .then(async (response) => {
          const { status, msg } = response.data;

          if (status == 200) {
            await this.setState((prevState) => {
              let { showRecorderModal, recordingFor } = prevState;
              showRecorderModal = flag;
              recordingFor = type;
              return { showRecorderModal, recordingFor };
            });
          }
          await this.setState({
            lowStorageStatus: status,
            lowStorageMessage: msg,
            showLowStoragePopup: status == 200 ? false : true,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      await this.setState((prevState) => {
        let { showRecorderModal, recordingFor } = prevState;
        showRecorderModal = flag;
        recordingFor = type;
        return { showRecorderModal, recordingFor };
      });
    }
  };

  startRecording = async () => {
    await this.setState({ recordAudio: true });
  };

  stopRecording = async () => {
    await this.setState({ recordAudio: false });
  };

  onStop = async (recordedBlob) => {
    let promise = new Promise((resolve, error) => {
      let reader = new FileReader();
      reader.readAsDataURL(recordedBlob.blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });

    promise.then(async (response) => {
      await this.setState((prevState) => {
        let {
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
        } = prevState;
        if (this.state.recordingFor === "control_measure") {
          controlMeasureAudio = recordedBlob.blob;
          controlMeasureURL = response;
        }
        if (this.state.recordingFor === "observation") {
          observationAudio = recordedBlob.blob;
          observationURL = response;

          console.log(observationURL, observationAudio);
        }
        return {
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
        };
      });
    });
  };

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  _removeAudioFile = async (type) => {
    await this.setState((prevState) => {
      if (type === "observation") {
        prevState.observationAudio = "";
        prevState.observationURL = "";
        return prevState;
      }

      if (type === "control_measure") {
        prevState.controlMeasureAudio = "";
        prevState.controlMeasureURL = "";
        return prevState;
      }
    });
  };

  _onTimeChange = async (options) => {
    const { hour, minute, meridiem } = options;

    const time = `${hour}:${minute}:00`;
    const formattedTime = moment(time, "HH:mm:").format("hh:mm");

    await this.setState({
      selectedIncidentTime: formattedTime,
      selectedTimeMeridiem: meridiem,
    });
  };

  _reportType = () => {
    if (this.state.reportType == "nm") {
      return "NM";
    } else if (this.state.reportType == "ira") {
      return "IRA";
    } else {
      return "UA/UC";
    }
  };

  _clearForm = async () => {
    await this.setState((prevState) => {
      prevState.projectList = [];
      prevState.departmentList = [];
      prevState.contractorList = [];
      prevState.zoneList = [];
      prevState.locationList = [];
      prevState.activityList = [];
      prevState.subActivityList = [];
      //prevState.selectedType = null;
      prevState.observationText = "";
      prevState.evidenceFileList = [];
      prevState.evidenceUrlList = [];
      prevState.selectedCompanyId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedCompanyId
          : null;
      prevState.selectedServiceId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedServiceId
          : null;
      prevState.selectedProjectId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedProjectId
          : null;
      prevState.selectedDepartmentId = null;
      prevState.selectedContractorId = null;
      prevState.selectedZoneId = null;
      prevState.selectedLocationId = null;
      prevState.selectedTypeAct = null;
      prevState.selectedActivity = null;
      prevState.conduct = [];
      prevState.male_attendees_count = 0;
      prevState.female_attendees_count = 0;
      prevState.selectedTargetDate = new Date();
      prevState.soiFormHidingField = {};
      prevState.nmFormHidingField = {};
      prevState.iraFormHidingField = {};
      prevState.isMaxPersonValidate = false;
      prevState.maxPersonValidationMessage = "";
      prevState.validDateField = "";
      // Add this line to clear tempFiles
      prevState.tempFiles = [];
      prevState.companyError = false;
      prevState.serviceError = false;
      prevState.projectError = false;
      prevState.employee_attendees_count = 0;
      prevState.contractor_attendees_count = 0;
      prevState.employee_attendees_countError = false;
      prevState.contractor_attendees_countError = false;
      prevState.zoneError = false;
      prevState.departmentError = false;
      prevState.contractorError = false;
      prevState.locationError = false;

      prevState.typeActError = false;
      prevState.activityError = false;
      prevState.typeError = false;
      prevState.isMaxPersonValidateError = false;
      prevState.observationError = false;

      prevState.topicError = false;
      prevState.selectedFacultyError = false;
      prevState.noOfAtendeesError = false;
      prevState.conduct = [];
      prevState.topic = "";
      //prevState.selectedType = null;
      //prevState.selectedType = this.props.reportType == "training" ? "1" : "2",
      prevState.selectedFaculty = null;
      prevState.noOfAtendees = "";
      prevState.selectedConductedStartDate = new Date();
      prevState.selectedConductedEndDate = new Date();

      prevState.showRecorderModal = false;
      prevState.recordAudio = false;
      prevState.observationAudio = "";
      prevState.observationURL = "";
      prevState.recordingFor = "observation";
      prevState.projectAutoFill = {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      };

      return prevState;
    });

    this.setState({
      searchFiledUsers: [],
      searchEmployeeUsers: [],
      searchData: [],
      searchEmployeeData: [],
    });
  };

  _continueReportingClearForm = async () => {
    await this.setState((prevState) => {
      prevState.observationText = "";
      prevState.evidenceFileList = [];
      prevState.evidenceUrlList = [];
      prevState.selectedCompanyId = null;
      prevState.selectedServiceId = null;
      prevState.selectedProjectId = null;
      prevState.conductedFor = null;
      prevState.selectedDivisionId = null;
      prevState.selectedDepartmentId = null;
      prevState.selectedContractorId = null;
      prevState.selectedZoneId = null;
      prevState.selectedLocationId = null;
      prevState.clearDropZone = false;
      prevState.selectedFile = "";
      //prevState.selectedType = null;
      prevState.selectedActivity = null;
      prevState.selectedSubActivity = null;
      prevState.isMaxPersonValidate = false;
      prevState.maxPersonValidationMessage = "";
      prevState.validDateField = "";
      prevState.topic = "";
      prevState.selectedTopic = null;
      prevState.selectedFaculty = null;
      prevState.noOfAtendees = "";
      prevState.selectedConductedStartDate = new Date();
      prevState.selectedConductedEndDate = new Date();
      prevState.male_attendees_count = 0;
      prevState.employee_attendees_count = null;
      prevState.contractor_attendees_count = null;
      prevState.trainingType = null;
      prevState.isSheduleChecked = false;
      prevState.tempFiles = [];
      prevState.conduct = [];
      prevState.female_attendees_count = 0;
      prevState.soiFormHidingField = {};
      prevState.nmFormHidingField = {};

      prevState.serviceError = false;
      prevState.projectError = false;

      prevState.zoneError = false;
      prevState.departmentError = false;
      prevState.contractorError = false;
      prevState.locationError = false;

      prevState.observationError = false;

      prevState.topicError = false;
      prevState.typeError = false;
      prevState.activityError = false;
      prevState.subActivityError = false;
      prevState.selectedFacultyError = false;
      prevState.noOfAtendeesError = false;

      prevState.showRecorderModal = false;
      prevState.recordAudio = false;
      prevState.observationAudio = "";
      prevState.observationURL = "";
      prevState.recordingFor = "observation";

      // clearing dropdown values
      prevState.serviceList = [];
      prevState.projectList = [];
      prevState.categoryList = [];
      prevState.departmentList = [];
      prevState.zoneList = [];
      prevState.locationList = [];
      prevState.activityList = [];
      prevState.subActivityList = [];
      prevState.divisionList = [];
      prevState.projectAutoFill = {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      };
      return prevState;
    });

    this.setState({
      searchFiledUsers: [],
      searchEmployeeUsers: [],
      searchData: [],
      searchEmployeeData: [],
    });
  };

  _addPersonName = async () => {
    await this.setState((prevState) => {
      let { personName, personNameList } = prevState;
      personNameList = [...personNameList, personName];
      personName = "";
      return { personName, personNameList };
    });
  };

  _removePersonName = async (position) => {
    await this.setState((prevState) => {
      let { personNameList } = prevState;
      personNameList.splice(position, 1);
      return { personNameList };
    });
  };

  _uploadFile = async (file) => {
    console.log("Adding file to Training parent:", file.name);
    if (file != null) {
      await this.setState((prevState) => {
        let { selectedFile, tempFiles } = prevState;
        selectedFile = file;
        tempFiles = [...tempFiles, file];
        return { selectedFile, tempFiles };
      });
    }
  };

  _removeUploadedFile = async (removedFile) => {
    console.log("Removing file from Training parent:", removedFile.name);

    await this.setState((prevState) => {
      let { tempFiles } = prevState;

      // Find and remove the file from tempFiles array
      const updatedFiles = tempFiles.filter((existingFile) => {
        // Compare multiple properties to ensure correct file identification
        return !(
          existingFile.name === removedFile.name &&
          existingFile.size === removedFile.size &&
          existingFile.type === removedFile.type &&
          existingFile.lastModified === removedFile.lastModified
        );
      });

      return { tempFiles: updatedFiles };
    });

    console.log("Updated tempFiles count:", this.state.tempFiles.length);
  };

  manageTrainingConductor = (val, isDelete, callback = {}, event) => {
    const temp = [...this.state.conduct];

    if (isDelete) {
      const itemIndex = temp.indexOf(val);
      this._handleChange(
        null,
        temp[itemIndex] === "Employee"
          ? "employee_attendees_count"
          : "contractor_attendees_count",
      );
      temp.splice(itemIndex, 1);
    } else {
      temp.push(val);
    }
    this.setState(
      { conduct: temp, conductedForError: temp.length === 0 },
      callback(event, this.state, temp),
    );
  };

  validateMaxPersonValue = (
    e,
    state,
    conduct = [],
    isRecurssionType = false,
    recurssionKey = "",
    recessionValue = 0,
  ) => {
    const { name, value } = e?.target ?? {};
    const {
      contractor_attendees_count,
      employee_attendees_count,
      female_attendees_count,
      male_attendees_count,
    } = state;

    // Auto-adjust employee/contractor count if conduct value changes
    if (["Employee", "Contractor"].includes(value)) {
      if (conduct.length === 1) {
        const count =
          parseInt(contractor_attendees_count ?? 0) +
          parseInt(employee_attendees_count ?? 0);
        const key =
          conduct[0] === "Employee"
            ? "employee_attendees_count"
            : "contractor_attendees_count";
        this._handleChange(count === 0 ? null : count, key);
      } else if (conduct.length === 2) {
        this._handleChange(
          employee_attendees_count !== null ? employee_attendees_count : null,
          "employee_attendees_count",
        );
        this._handleChange(
          contractor_attendees_count !== null
            ? contractor_attendees_count
            : null,
          "contractor_attendees_count",
        );
      }
    }

    // Validate if male + female = employee + contractor
    if (
      ["male_attendees_count", "female_attendees_count"].includes(name) ||
      isRecurssionType
    ) {
      const totalExpected =
        parseInt(contractor_attendees_count ?? 0) +
        parseInt(employee_attendees_count ?? 0);

      const fieldName = isRecurssionType ? recurssionKey : name;
      const inputValue = parseInt(isRecurssionType ? recessionValue : value);
      const otherValue =
        fieldName === "female_attendees_count"
          ? parseInt(male_attendees_count ?? 0)
          : parseInt(female_attendees_count ?? 0);

      const totalActual = inputValue + otherValue;

      const isInvalid = totalActual !== totalExpected;

      this.setState({
        isMaxPersonValidate: isInvalid,
        validDateField: isInvalid ? fieldName : "",
        maxPersonValidationMessage: isInvalid
          ? `${fieldName === "female_attendees_count" ? this.props.t("femaleAttendees") : this.props.t("maleAttendees")}  ${this.props.t("attendeesmessage")}`
          : "",
      });
    }
  };

  searchClientEmployee = async (inputString, callback) => {
    FetchEMList({ search: inputString })
      .then(async (response) => {
        console.log(response);

        if (response.status === 200) {
          callback(response.data);
          await this.setState({
            searchEmployeeData: {
              ...this.state.searchEmployeeData,
              ...response.data,
            },
          });
        }
      })
      .catch((error) => {});
  };

  searchTopics = async (inputString, callback) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    const requestParams = {
      auth_key: token,
      user_id: userId,
      search: inputString,
      type: this.state.selectedType || 0,
    };

    try {
      const response = await axios.get(Url.searchTopic, {
        params: requestParams,
        headers: { accept: "application/json" },
      });

      if (response.data.status === 200 && Array.isArray(response.data.data)) {
        // Convert API data to { label, value } format
        const items = response.data.data.map((topic) => ({
          label: topic.name,
          value: topic.id,
        }));

        callback(items);

        // Store in state if needed
        this.setState({
          searchTopicData: {
            ...this.state.searchTopicData,
            ...response.data,
          },
        });
      } else {
        callback([]); // No data
      }
    } catch (error) {
      callback([]); // API failed
    }
  };

  searchActiveUser = async (inputString, callback) => {
    // const contentType = { "Content-Type": "application/x-www-form-urlencoded" };
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      search: inputString,
    };
    await axios
      .get(Url.userSearch, {
        params: requestParams,
        headers: {
          accept: "application/json",
        },
      })
      .then(async (response) => {
        if (response.data.status === 200) {
          callback(response.data);
          await this.setState({
            searchData: { ...this.state.searchData, ...response.data },
          });
        }
      })
      .catch((error) => {});
  };

  _evaluateDeptZoneLocationRequirement = (overrides = {}) => {
    const {
      userData,
      formHideField,
      showZoneDropdown,
      selectedDepartmentId,
      selectedZoneId,
      selectedLocationId,
    } = this.state;

    const departmentId =
      "selectedDepartmentId" in overrides
        ? overrides.selectedDepartmentId
        : selectedDepartmentId;

    const zoneId =
      "selectedZoneId" in overrides ? overrides.selectedZoneId : selectedZoneId;

    const locationId =
      "selectedLocationId" in overrides
        ? overrides.selectedLocationId
        : selectedLocationId;

    const isDepartmentShown =
      userData?.div_dept === 0 &&
      !Object.values(formHideField || {}).includes("Department");

    const isZoneLocationShown = !!showZoneDropdown;

    const hasDepartment = !!departmentId;
    const hasZoneLocation = !!zoneId && !!locationId;

    // Neither field group is required
    if (!isDepartmentShown && !isZoneLocationShown) {
      return {
        departmentError: false,
        zoneError: false,
        locationError: false,
      };
    }

    // Only Department is required
    if (isDepartmentShown && !isZoneLocationShown) {
      return {
        departmentError: !hasDepartment,
        zoneError: false,
        locationError: false,
      };
    }

    // Only Zone + Location group is required
    if (!isDepartmentShown && isZoneLocationShown) {
      return {
        departmentError: false,
        zoneError: !hasZoneLocation,
        locationError: !hasZoneLocation,
      };
    }

    // Department OR (Zone + Location)
    const satisfied = hasDepartment || hasZoneLocation;

    return {
      departmentError: !satisfied,
      zoneError: !satisfied,
      locationError: !satisfied,
    };
  };

  render() {
    console.log("param_list  ", this.state);
    const { t } = this.props;
    const isOberserver = this.state.userData.designation_flag === 4;
    return (
      <>
        {/* Data Loading  */}
        <div
          className="loader"
          style={{ display: this.state.dataLoading ? "block" : "none" }}
        >
          <LoadingImage />
        </div>
        <div className="rd-content">
          <div className="rd-left-content">
            <div className="rd-box">
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    {/* <label className="form-label">Image/Video</label> */}
                    <div className="padding-l-r">
                      <ReportDropZone
                        type="5"
                        uploadFile={this._uploadFile}
                        removeFile={this._removeUploadedFile} // Add this line
                        disabledPlaceHolder
                        clearDropZone={this.state.clearDropZone}
                      />
                    </div>
                  </div>

                  <div>
                    <div
                      className={`slds-form-element padding-l-r ${
                        this.state.topicError ? "slds-has-error" : ""
                      }`}
                    >
                      <label className="slds-form-element__label">
                        Topic
                        <abbr className="slds-required" title="required">
                          *{" "}
                        </abbr>
                        {renderToolTip(
                          "You can not edit this field after submission",
                          "top",
                          {
                            width: "200px",
                            fontSize: "10px",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          },
                          1,
                          "Description",
                          true,
                        )}
                      </label>
                      <div className="slds-form-element__control">
                        <AsyncSelect
                          isMulti={false}
                          cacheOptions
                          defaultOptions
                          value={this.state.selectedTopic || null}
                          placeholder="Search Topic"
                          onChange={(selected) => {
                            if (selected) {
                              // User selected from dropdown
                              this.setState({
                                selectedTopic: selected,
                                topic: selected.label,
                                topicId: selected.value,
                                topicError: false,
                              });
                            }
                          }}
                          loadOptions={(inputValue, callback) => {
                            if (this.timeout) clearTimeout(this.timeout);

                            this.timeout = setTimeout(() => {
                              this.searchTopics(inputValue, (options) => {
                                if (
                                  options.length === 0 &&
                                  inputValue.trim() !== ""
                                ) {
                                  // Add custom value if not found
                                  options.push({ label: inputValue, value: 0 });
                                }
                                callback(options);
                              });
                            }, 500);
                          }}
                        />
                      </div>
                      {!!this.state.topicError && (
                        <div className="slds-form-element__help">
                          {requiredMessage}
                        </div>
                      )}
                    </div>

                    <div
                      className={`slds-form-element padding-l-r ${
                        this.state.observationError ? "slds-has-error" : ""
                      }`}
                    >
                      <div className="with-mic">
                        <label className="slds-form-element__label">
                          What all covered
                          <abbr class="slds-required" title="required">
                            *{" "}
                          </abbr>
                        </label>
                      </div>
                      {this.state.observationURL ? (
                        <div className="audioPreviewer mt-2">
                          <AudioPlayer
                            src={this.state.observationURL}
                            showJumpControls={true}
                            layout="horizontal-reverse"
                            customVolumeControls={[]}
                            customAdditionalControls={[]}
                            style={{
                              width: "600px",
                            }}
                          />
                          <Button
                            variant="outline-primary"
                            onClick={() => this._removeAudioFile("observation")}
                          >
                            X
                          </Button>
                        </div>
                      ) : null}
                      <div className="slds-form-element__control">
                        <textarea
                          className="slds-textarea"
                          onChange={(event) =>
                            this._handleChange(
                              event.target.value,
                              "observation",
                            )
                          }
                          value={this.state.observationText}
                          placeholder="Write what all covered description"
                        ></textarea>
                      </div>
                      {!!this.state.observationError && (
                        <div class="slds-form-element__help" id="error-01">
                          {requiredMessage}
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    {/* <div className="rd-box-head">
                      <h3>Service & Plant/Project</h3>
                    </div> */}
                    {!isOberserver && !this.props.isFromAction ? (
                      <>
                        {this.state.organisationSetting && (
                          <Row>
                            <Col>
                              <CompanyList
                                optionList={this.state.companyList || []}
                                onChangeHandle={this._companyChangeHandle}
                                value={this.state.selectedCompanyId}
                                hasError={this.state.companyError}
                                searchable={true}
                                customSelectStyles={customSelectStyles}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col>
                            <ServiceList
                              optionList={this.state.serviceList}
                              onChangeHandle={this._serviceChangeHandle}
                              value={this.state.selectedServiceId}
                              hasError={this.state.serviceError}
                              searchable={true}
                              customSelectStyles={customSelectStyles}
                            />
                          </Col>
                          <Col>
                            <ProjectList
                              optionList={this.state.projectList}
                              onChangeHandle={this._projectChangeHandle}
                              value={this.state.selectedProjectId}
                              hasError={this.state.projectError}
                              searchable={true}
                              customSelectStyles={customSelectStyles}
                              customPlaceHolder="PPC"
                            />
                          </Col>
                        </Row>
                      </>
                    ) : null}
                    {this.state.organisationSetting && (
                      <div
                        className="mb-2"
                        style={{
                          border: "1px solid #eaeaea",
                          borderRadius: 8,
                          padding: 12,
                          margin: 12,
                        }}
                      >
                        <label className="slds-form-element__label">
                          Project Details
                        </label>
                        <div
                          style={{ display: "flex", flexWrap: "wrap", gap: 12 }}
                        >
                          <div
                            style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                          >
                            <label className="slds-form-element__label">
                              Project Category
                            </label>
                            <input
                              className="form-control"
                              disabled
                              value={
                                this.state.projectAutoFill.projectCategory || ""
                              }
                              placeholder="Auto-filled"
                            />
                          </div>
                          <div
                            style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                          >
                            <label className="slds-form-element__label">
                              Region
                            </label>
                            <input
                              className="form-control"
                              disabled
                              value={this.state.projectAutoFill.region || ""}
                              placeholder="Auto-filled"
                            />
                          </div>
                          <div
                            style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                          >
                            <label className="slds-form-element__label">
                              State
                            </label>
                            <input
                              className="form-control"
                              disabled
                              value={this.state.projectAutoFill.state || ""}
                              placeholder="Auto-filled"
                            />
                          </div>
                          <div
                            style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                          >
                            <label className="slds-form-element__label">
                              City
                            </label>
                            <input
                              className="form-control"
                              disabled
                              value={this.state.projectAutoFill.city || ""}
                              placeholder="Auto-filled"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <Row>
                      {this.state.userData?.div_dept == 1 && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("division")}
                            optionList={this.state.divisionList}
                            onChangeHandle={this._divisionChangeHandle}
                            isRequired={true}
                            value={this.state.selectedDivisionId}
                            hasError={this.state.divisionError}
                          />
                          {!!this.state.divisionError && (
                            <p className="inputErrorMsg">{requiredMessage}</p>
                          )}
                        </Col>
                      )}
                      {this.state.userData?.div_dept === 0 && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("department")}
                            optionList={this.state.departmentList}
                            onChangeHandle={this._departmentChangeHandle}
                            isRequired={true}
                            value={this.state.selectedDepartmentId}
                            hasError={this.state.departmentError}
                          />
                        </Col>
                      )}
                      {this.state.showZoneDropdown && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("zone")}
                            optionList={this.state.zoneList}
                            onChangeHandle={this._zoneChangeHandle}
                            isRequired={true}
                            value={this.state.selectedZoneId}
                            hasError={this.state.zoneError}
                          />
                        </Col>
                      )}
                      {!!this.state.showZoneDropdown && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("location")}
                            optionList={this.state.locationList}
                            onChangeHandle={this._locationChangeHandle}
                            isRequired={true}
                            value={this.state.selectedLocationId}
                            hasError={this.state.locationError}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>
                <Col sm={6}>
                  <div>
                    {!this.props.isFromAction && (
                      <Row>
                        <Col sm={6}>
                          <CommonDropdown
                            title="Activity"
                            optionList={this.state.activityList}
                            onChangeHandle={this._activityChangeHandle}
                            value={this.state.selectedActivity}
                            hasError={this.state.activityError}
                            searchable={true}
                            customSelectStyles={customSelectStyles}
                            customStyle={true}
                          />
                        </Col>
                        {this.state.param_list?.subActivity &&
                          this.state.subActivityList?.length > 0 && (
                            <Col sm={6}>
                              <CommonDropdown
                                title="Sub-Activity"
                                optionList={this.state.subActivityList}
                                onChangeHandle={this._subActivityChangeHandle}
                                isRequired={true}
                                value={this.state.selectedSubActivity}
                                hasError={this.state.subActivityError}
                                searchable={true}
                                customSelectStyles={customSelectStyles}
                                customStyle={true}
                              />
                            </Col>
                          )}
                        <Col
                          sm={6}
                          className={`slds-form-element ${
                            this.state.conductedForError ? "slds-has-error" : ""
                          }`}
                        >
                          <div className="rd-box-head">
                            <label className="slds-form-element__label font-18">
                              Conducted For
                            </label>
                          </div>
                          <div>
                            <div className="d-flex">
                              <div className="slds-form-element__control">
                                <div className="slds-checkbox">
                                  <input
                                    name="internal"
                                    type="checkbox"
                                    id="checkbox-unique-id-160"
                                    value="Employee"
                                    checked={this.state.conduct.includes(
                                      "Employee",
                                    )}
                                    onChange={(event) => {
                                      this.manageTrainingConductor(
                                        "Employee",
                                        this.state.conduct.includes("Employee"),
                                        this.validateMaxPersonValue,
                                        event,
                                      );
                                    }}
                                  />
                                  <label
                                    className="slds-checkbox__label"
                                    for="checkbox-unique-id-160"
                                  >
                                    <span className="slds-checkbox_faux"></span>
                                    <span className="slds-form-element__label">
                                      Employee
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div className="slds-form-element__control">
                                <div className="slds-checkbox">
                                  <input
                                    name="internal"
                                    type="checkbox"
                                    id="checkbox-unique-id-161"
                                    value="Contractor"
                                    checked={this.state.conduct.includes(
                                      "Contractor",
                                    )}
                                    onChange={(event) => {
                                      this.manageTrainingConductor(
                                        "Contractor",
                                        this.state.conduct.includes(
                                          "Contractor",
                                        ),
                                        this.validateMaxPersonValue,
                                        event,
                                      );
                                    }}
                                  />
                                  <label
                                    className="slds-checkbox__label"
                                    for="checkbox-unique-id-161"
                                  >
                                    <span className="slds-checkbox_faux"></span>
                                    <span className="slds-form-element__label">
                                      Contractor
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            {!!this.state.conductedForError && (
                              <div
                                class="slds-form-element__help"
                                id="error-01"
                              >
                                {requiredMessage}
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col>
                        {this.state.selectedType === "1" ? (
                          <div
                            className={`slds-form-element ${
                              this.state.trainingTypeError
                                ? "slds-has-error"
                                : ""
                            }`}
                          >
                            <div className="rd-box-head">
                              <label className="slds-form-element__label font-18">
                                Training Type
                              </label>
                            </div>
                            <div className="d-flex  ">
                              <div className="slds-form-element__control">
                                <div className="slds-checkbox">
                                  <input
                                    name="internal"
                                    type="checkbox"
                                    value="Internal"
                                    id="checkbox-unique-id-155"
                                    checked={
                                      this.state.trainingType == "Internal"
                                    }
                                    onChange={(event) =>
                                      this._handleChange(
                                        event.target.value,
                                        "training_type",
                                      )
                                    }
                                  />
                                  <label
                                    className="slds-checkbox__label"
                                    for="checkbox-unique-id-155"
                                  >
                                    <span className="slds-checkbox_faux"></span>
                                    <span className="slds-form-element__label">
                                      Internal
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div className="slds-form-element__control">
                                <div className="slds-checkbox">
                                  <input
                                    name="external"
                                    type="checkbox"
                                    value="External"
                                    id="checkbox-unique-id-154"
                                    checked={
                                      this.state.trainingType == "External"
                                    }
                                    onChange={(event) =>
                                      this._handleChange(
                                        event.target.value,
                                        "training_type",
                                      )
                                    }
                                  />
                                  <label
                                    className="slds-checkbox__label"
                                    for="checkbox-unique-id-154"
                                  >
                                    <span className="slds-checkbox_faux"></span>
                                    <span className="slds-form-element__label">
                                      External
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            {!!this.state.trainingTypeError && (
                              <div
                                class="slds-form-element__help"
                                id="error-01"
                              >
                                {requiredMessage}
                              </div>
                            )}
                          </div>
                        ) : null}
                      </Col>

                      <Col>
                        {this.state.selectedType === "1" ? (
                          <div className="slds-form-element">
                            <div className="rd-box-head">
                              <label className="slds-form-element__label font-18">
                                Scheduled
                              </label>
                            </div>
                            <div className="slds-form-element__control">
                              <div className="slds-checkbox">
                                <input
                                  name="options"
                                  id="checkbox-unique-id-164"
                                  type="checkbox"
                                  checked={this.state.isSheduleChecked}
                                  onChange={() => {
                                    this._handleCheck();
                                  }}
                                />
                                <label
                                  className="slds-checkbox__label"
                                  for="checkbox-unique-id-164"
                                >
                                  <span className="slds-checkbox_faux"></span>
                                  <span className="slds-form-element__label">
                                    Scheduled
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <div>
                          <div className="rd-box-head">
                            <label className="slds-form-element__label font-18">
                              Conducted Date & Time
                            </label>
                          </div>
                        </div>
                      </Col>

                      {this.state.isSheduleChecked == true ? (
                        <Col sm={6}>
                          <div>
                            <label className="slds-form-element__label">
                              Start Date & Time
                            </label>
                            <div className="calender-div">
                              <DatePicker
                                selected={this.state.selectedConductedStartDate}
                                minDate={this.state.maxDatepickerDate}
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                popperPlacement="left"
                                popperModifiers={{
                                  flip: { behavior: ["bottom"] },
                                  preventOverflow: { enabled: false },
                                  hide: { enabled: false },
                                }}
                                onChange={(jsDate) =>
                                  this._handleChange(
                                    jsDate,
                                    "conducted_start_date",
                                  )
                                }
                              />
                              <Calendar className="calender-icon" />
                            </div>
                          </div>
                        </Col>
                      ) : (
                        <Col sm={12}>
                          <div>
                            <label className="slds-form-element__label">
                              Start Date & Time
                            </label>
                            <div className="calender-div">
                              <DatePicker
                                selected={this.state.selectedConductedStartDate}
                                maxDate={this.state.minDatepickerDate}
                                showTimeSelect
                                timeFormat="HH:mm"
                                // popperPlacement="left"
                                // popperModifiers={{
                                //   flip: { behavior: ["bottom"] },
                                //   preventOverflow: { enabled: false },
                                //   hide: { enabled: false },
                                // }}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                onChange={(jsDate) =>
                                  this._handleChange(
                                    jsDate,
                                    "conducted_start_date",
                                  )
                                }
                              />
                              <Calendar className="calender-icon" />
                            </div>
                          </div>
                        </Col>
                      )}

                      {this.state.selectedType === "1" ? (
                        this.state.isSheduleChecked == true ? (
                          <Col sm={6}>
                            <div>
                              <label className="slds-form-element__label">
                                End Date & Time
                              </label>
                              <div className="calender-div">
                                <DatePicker
                                  selected={this.state.selectedConductedEndDate}
                                  minDate={
                                    this.state.selectedConductedStartDate
                                  }
                                  showTimeSelect
                                  popperPlacement="left"
                                  timeFormat="HH:mm"
                                  dateFormat="dd/MM/yyyy HH:mm:ss"
                                  onChange={(jsDate) =>
                                    this._handleChange(
                                      jsDate,
                                      "conducted_end_date",
                                    )
                                  }
                                />
                                <Calendar className="calender-icon" />
                              </div>
                            </div>
                          </Col>
                        ) : (
                          <Col sm={6}>
                            <div>
                              <label className="slds-form-element__label">
                                End Date & Time
                              </label>
                              <div className="calender-div">
                                <DatePicker
                                  selected={this.state.selectedConductedEndDate}
                                  minDate={
                                    this.state.selectedConductedStartDate
                                  }
                                  maxDate={this.state.currentDate}
                                  showTimeSelect
                                  timeFormat="HH:mm"
                                  dateFormat="dd/MM/yyyy HH:mm:ss"
                                  onChange={(jsDate) =>
                                    this._handleChange(
                                      jsDate,
                                      "conducted_end_date",
                                    )
                                  }
                                  popperPlacement="left"
                                />
                                <Calendar className="calender-icon" />
                              </div>
                            </div>
                          </Col>
                        )
                      ) : null}
                      {this.state.selectedType !== null &&
                      this.state.selectedType != "3" ? (
                        <>
                          {this.state.conduct.includes("Employee") ? (
                            <Col sm={6}>
                              <div
                                className={`slds-form-element ${
                                  this.state.employee_attendees_countError
                                    ? "slds-has-error"
                                    : ""
                                }`}
                              >
                                <label className="slds-form-element__label">
                                  Employee Attendees{" "}
                                  <abbr class="slds-required" title="required">
                                    *{" "}
                                  </abbr>
                                </label>
                                <input
                                  className="slds-input"
                                  value={this.state.employee_attendees_count}
                                  type="text"
                                  name="employee_attendees_count"
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    if (value === "-") {
                                      this._handleChange(
                                        "",
                                        "employee_attendees_count",
                                      );
                                    }
                                    if (
                                      value === "0" ||
                                      value === "" ||
                                      isIntegerNumber(value)
                                    ) {
                                      this._handleChange(
                                        value,
                                        "employee_attendees_count",
                                      );
                                      this.validateMaxPersonValue(
                                        event,
                                        this.state,
                                        [],
                                        true,
                                        "female_attendees_count",
                                        value,
                                      );
                                    }
                                  }}
                                  placeholder={"Enter Employee Attendees"}
                                />
                                {!!this.state.employee_attendees_countError &&
                                  (this.state.employee_attendees_countError <
                                  0 ? (
                                    <div
                                      class="slds-form-element__help"
                                      id="error-01"
                                    >
                                      {" "}
                                      Negative numbers are not allowed
                                    </div>
                                  ) : (
                                    <div
                                      class="slds-form-element__help"
                                      id="error-01"
                                    >
                                      {requiredMessage}
                                    </div>
                                  ))}
                              </div>
                            </Col>
                          ) : null}
                          {this.state.conduct.includes("Contractor") ? (
                            <Col sm={6}>
                              <div
                                className={`slds-form-element ${
                                  this.state.contractor_attendees_countError
                                    ? "slds-has-error"
                                    : ""
                                }`}
                              >
                                <label className="slds-form-element__label">
                                  <abbr class="slds-required" title="required">
                                    *{" "}
                                  </abbr>{" "}
                                  Contractor Attendees
                                </label>
                                <input
                                  className="slds-input"
                                  value={this.state.contractor_attendees_count}
                                  type="text"
                                  name="contractor_attendees_count"
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    if (value === "-") {
                                      this._handleChange(
                                        "",
                                        "contractor_attendees_count",
                                      );
                                    }
                                    if (
                                      value === "0" ||
                                      value === "" ||
                                      isIntegerNumber(value)
                                    ) {
                                      this._handleChange(
                                        value,
                                        "contractor_attendees_count",
                                      );
                                      this.validateMaxPersonValue(
                                        event,
                                        this.state,
                                        [],
                                        true,
                                        "female_attendees_count",
                                        value,
                                      );
                                    }
                                  }}
                                  placeholder={"Enter Contractor Attendees"}
                                />
                                {!!this.state.contractor_attendees_countError &&
                                  (this.state.contractor_attendees_countError <
                                  0 ? (
                                    <div
                                      class="slds-form-element__help"
                                      id="error-01"
                                    >
                                      {" "}
                                      Negative numbers are not allowed
                                    </div>
                                  ) : (
                                    <div
                                      class="slds-form-element__help"
                                      id="error-01"
                                    >
                                      {requiredMessage}
                                    </div>
                                  ))}
                              </div>
                            </Col>
                          ) : null}{" "}
                        </>
                      ) : (
                        <Col></Col>
                      )}

                      <Col sm={6}>
                        {this.state.selectedType !== null &&
                        this.state.selectedType != "3" ? (
                          <div
                            className={`slds-form-element ${
                              this.state.selectedFacultyError
                                ? "slds-has-error"
                                : ""
                            }`}
                          >
                            <label className="slds-form-element__label">
                              Faculty
                              <abbr class="slds-required" title="required">
                                *{" "}
                              </abbr>
                            </label>
                            <div className="slds-form-element__control">
                              <input
                                className="slds-input"
                                value={this.state.selectedFaculty || ""}
                                onChange={(event) => {
                                  if (!hasNumber.test(event.target.value)) {
                                    this._handleChange(
                                      event.target.value,
                                      "faculty",
                                    );
                                  }
                                }}
                                placeholder={"Enter Faculty Name"}
                              />
                            </div>
                            {!!this.state.selectedFacultyError && (
                              <div
                                class="slds-form-element__help"
                                id="error-01"
                              >
                                {requiredMessage}
                              </div>
                            )}
                          </div>
                        ) : null}
                      </Col>
                      {this.state.selectedType !== null &&
                      this.state.selectedType != "3" ? (
                        <>
                          {!!this.state.param_list?.maleAttendance && (
                            <Col sm={6}>
                              <div
                                className={`slds-form-element ${
                                  this.state.validDateField ==
                                  "male_attendees_count"
                                    ? "slds-has-error"
                                    : ""
                                }`}
                              >
                                <label className="slds-form-element__label">
                                  Male Attendees
                                </label>
                                {/* <span className="inputErrorMsg">&nbsp;*</span> */}
                                <input
                                  className="slds-input"
                                  value={this.state.male_attendees_count}
                                  type="text"
                                  name="male_attendees_count"
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    if (value === "-") {
                                      this._handleChange(
                                        "",
                                        "male_attendees_count",
                                      );
                                    }
                                    if (
                                      value === "0" ||
                                      value === "" ||
                                      isIntegerNumber(value)
                                    ) {
                                      this._handleChange(
                                        event.target.value,
                                        "male_attendees_count",
                                      );
                                      this.validateMaxPersonValue(
                                        event,
                                        this.state,
                                      );
                                    }
                                  }}
                                  placeholder={"Enter Number of Attendees"}
                                />
                                {this.state.validDateField ==
                                  "male_attendees_count" &&
                                  this.state.isMaxPersonValidate && (
                                    <div
                                      class="slds-form-element__help"
                                      id="error-01"
                                    >
                                      {this.state.maxPersonValidationMessage}
                                    </div>
                                  )}
                              </div>
                            </Col>
                          )}
                          {!!this.state.param_list?.femaleAttendance && (
                            <Col sm={6}>
                              <div
                                className={`slds-form-element ${
                                  this.state.validDateField ==
                                  "female_attendees_count"
                                    ? "slds-has-error"
                                    : ""
                                }`}
                              >
                                <label className="slds-form-element__label">
                                  Female Attendees
                                </label>
                                {/* <span className="inputErrorMsg">&nbsp;*</span> */}
                                <input
                                  className="slds-input"
                                  value={this.state.female_attendees_count}
                                  type="text"
                                  name="female_attendees_count"
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    if (value === "-") {
                                      this._handleChange(
                                        "",
                                        "female_attendees_count",
                                      );
                                    }
                                    if (
                                      value === "0" ||
                                      value === "" ||
                                      isIntegerNumber(value)
                                    ) {
                                      this._handleChange(
                                        event.target.value,
                                        "female_attendees_count",
                                      );
                                      this.validateMaxPersonValue(
                                        event,
                                        this.state,
                                      );
                                    }
                                  }}
                                  placeholder={"Enter Number of Attendees"}
                                />
                                {this.state.validDateField ==
                                  "female_attendees_count" &&
                                  this.state.isMaxPersonValidate && (
                                    <div
                                      class="slds-form-element__help"
                                      id="error-01"
                                    >
                                      {this.state.maxPersonValidationMessage}
                                    </div>
                                  )}
                              </div>
                            </Col>
                          )}
                        </>
                      ) : null}
                    </Row>
                    {!!(
                      // this.state.selectedServiceId !== null &&
                      // this.state.selectedProjectId !== null &&
                      !!this.state.param_list?.clientEmployeeMaster
                    ) && (
                      <Col sm={12} className="my-2">
                        <div className="slds-form-element">
                          <label className="slds-form-element__label">
                            {t("searchEmployee")}
                          </label>
                          <div className="w-100">
                            <AsyncSelect
                              isMulti={true}
                              cacheOptions
                              value={this.state.searchEmployeeUsers || []}
                              onChange={(data) => {
                                const items = data?.map((el) => ({
                                  ...el,
                                  employeeId: el?.clientEmployeeId,
                                  incident_person_id: el?.clientEmployeeId,
                                  incident_person_name: el?.label,
                                }));

                                this.setState({
                                  searchEmployeeUsers: items || [],
                                });
                              }}
                              placeholder={t("searchEmployee")}
                              loadOptions={(input, callback) => {
                                if (this.timeout) clearTimeout(this.timeout);

                                this.timeout = setTimeout(() => {
                                  this.searchClientEmployee(input, (data) => {
                                    const items = data?.map((element) => ({
                                      ...element,
                                      label: element?.displayName,
                                      value: element?.clientEmployeeId,
                                    }));

                                    callback(items);
                                  });
                                }, 1000);
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    )}
                    <Row>
                      {!!(
                        // this.state.selectedServiceId !== null &&
                        // this.state.selectedProjectId !== null &&
                        (
                          !!this.state.param_list?.activeUser ||
                          !!this.state.param_list?.cleintEmployeeSearch
                        )
                      ) && (
                        <Col sm={12} className="my-2">
                          <div className="slds-form-element">
                            <label className="slds-form-element__label">
                              {this.state.reportType == "ira"
                                ? t("searchEmployee")
                                : t("activeUser")}
                            </label>
                            <div className="w-100">
                              <AsyncSelect
                                isMulti
                                cacheOptions
                                value={this.state.searchFiledUsers || []}
                                onChange={(data) => {
                                  const items = data?.map((el) => ({
                                    ...el,
                                    incident_person_id: el?.value,
                                    incident_person_name: el?.label,
                                  }));

                                  this.setState({
                                    searchFiledUsers: items || [],
                                  });
                                }}
                                placeholder={
                                  this.state.reportType == "ira"
                                    ? t("searchEmployee")
                                    : t("activeUser")
                                }
                                loadOptions={(input, callback) => {
                                  if (this.timeout) clearTimeout(this.timeout);

                                  this.timeout = setTimeout(() => {
                                    this.searchActiveUser(input, (data) => {
                                      const items = data?.data.map(
                                        (element) => ({
                                          ...element,
                                          label: element?.name,
                                          value: element?.id,
                                        }),
                                      );

                                      callback(items);
                                    });
                                  }, 1000);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        {/* <div className="publish-btn">
          <Button
            variant="secondary"
            onClick={this.props.close}
            className="gray-btn"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this._submitTraining}
            className="red-btn"
          >
            REPORT
          </Button>
        </div> */}

        <Modal
          show={this.state.showRecorderModal}
          dialogClassName="modal-90w"
          aria-labelledby="Voice Recording"
          onHide={() => this._showRecorder(false)}
          className="recordingModal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Record</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div>
                <Button onClick={this.startRecording} className="red-btn">
                  <Mic />
                </Button>
                <Button onClick={this.stopRecording} className="gray-btn">
                  <MicOff />
                </Button>
              </div>
              <div className="obervationRecording">
                {/* <ReactMic
                  record={this.state.recordAudio}
                  className="sound-wave"
                  onStop={this.onStop}
                  //strokeColor="#000000"
                  mimeType="audio/mp3"
                  strokeColor="#000000"
                  backgroundColor="#FF4081"
                /> */}
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showRecorderModal}
          dialogClassName="modal-90w"
          aria-labelledby="Voice Recording"
          onHide={() => this._showRecorder(false)}
          className="recordingModal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="obervationRecording">
              <ReactMic
                record={this.state.recordAudio}
                className="sound-wave"
                onStop={this.onStop}
                strokeColor="#000000"
                mimeType="audio/mp3"
                // strokeColor="#000000"
                backgroundColor="#FF4081"
              />

              {/* <VoiceRecorder
                onStop={this.onStop}
                stopRecording={this.stopRecording}
              /> */}
            </div>

            <div className="modal-footer-btn">
              <Button onClick={this.startRecording} className="red-btn">
                <Mic /> Start Recording
              </Button>
              <Button onClick={this.stopRecording} className="gray-btn">
                <MicOff /> Stop Recording
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          centered
          show={this.state.sucesssPopup}
          className="recordingModal"
          onHide={this._closeSuccessPopup}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body className="text-center">
            <img
              className="submit-img"
              //src={require("assets/images/submit.png")}
              src={SubmitImage}
              alt="submit_image"
            />
            <p className="report-submit-text"> Thank you for Reporting! </p>
            <p className="report-submit-text"> You have reported </p>
            <p className="report-submit-text">
              {this.state.reportNumber || 0}
              {this.state.activeModule == 1
                ? " Trainings till today"
                : " TBTs till today"}
            </p>

            <div className="modal-footer-btn">
              <button
                type="submit"
                className="red-btn"
                onClick={this._closeSuccessPopup}
              >
                GOTO DASHBOARD
              </button>
              <button
                type="submit"
                className="red-btn"
                onClick={this._continueReporting}
              >
                CONTINUE, REPORTING
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {this.state.showLowStoragePopup ? (
          <LowSpace
            message={this.state.lowStorageMessage}
            handleLowSpace={this._handleLowSpace}
          />
        ) : null}
      </>
    );
  }
}

export default compose(
  withRouter,
  withTranslation(["report", "util"]),
)(TrainingReport);
